import React, { useEffect, useState } from "react";
import axios from "axios";

import Loading from "../../../../Extra/Loading";
import NoDataFound from "../../../../Extra/NoDataFound";
import { getCurrentDate, getCurrentMonthFirstDate } from "../../../../Utilitie";
import { BiSolidReport } from "react-icons/bi";
import DurationWiseReport from "./DurationWiseReport";
import SpeedWiseReport from "./SpeedWiseReport";

const CautionOrderMaster = ({}) => {
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const [active, setActive] = useState("Long Duration Wise Caution");

  const [startDate, setStartDate] = useState(getCurrentMonthFirstDate());
  const [endDate, setEndDate] = useState(getCurrentDate());

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const fetchedData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}getCautionOrderBasedOnDays?start=${startDate}&end=${endDate}`,
      );
      if (response.data.status === "ok") {
        setData(response.data.data);
      } else {
        setData([]);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  const fetchedData2 = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}getSpeedWiseCautionOrder?start=${startDate}&end=${endDate}`,
      );
      if (response.data.status === "ok") {
        setData2(response.data.data);
      } else {
        setData2([]);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchedData();
    fetchedData2();
  }, []);

  return (
    <div>
      <div className="papaDiv"></div>
      <div className="bg-dark text-white p-1 d-flex justify-content-between align-items-center papaDiv">
        <div>
          <h5 className="text-center">
            {" "}
            <BiSolidReport />
            Caution Order
            <b style={{ color: "#b2b0b0ff" }}> (report)</b>
          </h5>
        </div>
        <div className="d-flex">
          <div className="m-1">
            <b>Start Date</b>
            <input
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
          </div>
          <div className="m-1">
            <b>End Date</b>
            <input
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
          </div>
          <button
            className="ms-1 btn btn-sm btn-outline-light"
            onClick={fetchedData}
          >
            Fetch
          </button>
        </div>
      </div>
      <div className="row m-5">
        <div className="d-flex justify-content-center m-2">
          <button
            onClick={() => {
              setActive("Long Duration Wise Caution");
            }}
            className={`btn btn-sm btn-outline-dark me-1 ${
              active === "Long Duration Wise Caution" && "active"
            }`}
          >
            Long Duration Wise Caution
          </button>
          <button
            onClick={() => {
              setActive("Speed Wise Caution");
            }}
            className={`btn btn btn-outline-dark ms-1 ${
              active === "Speed Wise Caution" && "active"
            }`}
          >
            Speed Wise Caution
          </button>
          <hr />
        </div>
      </div>
      <div className="">
        <div className="position-relative">
          {loading && <Loading />}
          {active === "Long Duration Wise Caution" && (
            <DurationWiseReport
              data={data}
              startDate={startDate}
              endDate={endDate}
            />
          )}

          {data.length === 0 && <NoDataFound />}
        </div>
        <div>
          {active === "Speed Wise Caution" && (
            <SpeedWiseReport
              data={data2}
              startDate={startDate}
              endDate={endDate}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CautionOrderMaster;
